import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  EntityAction,
  ErrorAction,
  Action as PlainAction,
} from '../../../store/types';

export interface RolloutHistoryState {
  view: {
    loadingHistory: boolean;
  };
}

export const initialState: RolloutHistoryState = {
  view: {
    loadingHistory: false,
  },
};

type Action =
  | PlainAction<ActionType.FETCH_ROLLOUT_HISTORY_STARTED>
  | EntityAction<ActionType.FETCH_ROLLOUT_HISTORY_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_ROLLOUT_HISTORY_FAILED>;

const rolloutHistoryReducer: Reducer<RolloutHistoryState, Action> = (
  state: RolloutHistoryState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case ActionType.FETCH_ROLLOUT_HISTORY_STARTED:
      return {
        ...state,
        view: {
          ...state.view,
          loadingHistory: true,
        },
      };

    case ActionType.FETCH_ROLLOUT_HISTORY_SUCCEEDED:
    case ActionType.FETCH_ROLLOUT_HISTORY_FAILED:
      return {
        ...state,
        view: {
          ...state.view,
          loadingHistory: false,
        },
      };

    default:
      return state;
  }
};

export default rolloutHistoryReducer;
